// extracted by mini-css-extract-plugin
module.exports = {"card":"card__3ioBP","submission-completed-at":"submission-completed-at__IpDH5","review-complete-badge":"review-complete-badge__2UGEU"};